import { isTokenExpired } from './jwt';

const KEYS = {
  token: 'authToken',
  type: 'tokenType',
  username: 'username',
  role: 'role',
  depts: 'depts',
  userId: 'userId',
};

export function readAuth() {
  const token = localStorage.getItem(KEYS.token);
  if (!token || isTokenExpired(token)) {
    if (token) clearAuth();
    return null;
  }
  let depts = [];
  try {
    depts = JSON.parse(localStorage.getItem(KEYS.depts) || '[]');
  } catch {
    depts = [];
  }
  const id = localStorage.getItem(KEYS.userId);
  return {
    token,
    tokenType: localStorage.getItem(KEYS.type) || 'Bearer',
    username: localStorage.getItem(KEYS.username) || '',
    role: localStorage.getItem(KEYS.role) || '',
    depts,
    id: id ? Number(id) : null,
  };
}

export function writeAuth({ token, tokenType, username, role, depts, id }) {
  if (token != null) localStorage.setItem(KEYS.token, token);
  if (tokenType != null) localStorage.setItem(KEYS.type, tokenType);
  if (username != null) localStorage.setItem(KEYS.username, username);
  if (role != null) localStorage.setItem(KEYS.role, role);
  if (depts != null) localStorage.setItem(KEYS.depts, JSON.stringify(depts));
  if (id != null) localStorage.setItem(KEYS.userId, String(id));
}

export function clearAuth() {
  Object.values(KEYS).forEach((k) => localStorage.removeItem(k));
}

export function readToken() {
  return localStorage.getItem(KEYS.token);
}

export const AUTH_STORAGE_KEYS = KEYS;
